import request from '../utils/request';

/**
 * @description: 获取我的车库车辆列表
 * @param {*} data 
 */
export function getCars(data) {
  return request({
    url: '/api/weixin/ownerGarage?openId='+data.openId,
    method: 'post'
  })
}

/**
 * @description: 获取我的车库车辆列表  main.js引用
 * @param {*} data 
 */
export function getOpenId(data) {
  return request({
    url: '/api/weixin/getOpenId?codeParam='+data.codeParam,
    method: 'post',
    data,
  })
}
/**
 * @description: 获取我的车库车辆列表  main.js引用
 * @param {*} code 
 */
 export function getOpenIdNew(code) {
    return request({
      url: '/api/weixin/queryOpenId?wxcode='+code,
      method: 'get',
    })
  }

/**
 * @description: 获取车辆信息
 * @param {*} data 
 */
export function getCarInfoByCarOwnerId(data) {
  return request({
    url: '/api/weixin/getCarInfoByCarOwnerId?carOwnerId='+data.carOwnerId,
    method: 'post',
  })
}